import { contentConstraintHasDDBAnnotation } from "../../../../utils/annotations";

export const getDataflowDDBContentConstraint = (dataflowProductionModalDataflow, dataflowProductionModalContentConstraints, 
  annotationsConfig) => {
  const dataflowDDBContentConstraints = 
    dataflowProductionModalDataflow !== null
    ? dataflowProductionModalDataflow.HasContentConstraints
      ? (dataflowProductionModalContentConstraints || []).filter(cc => 
        contentConstraintHasDDBAnnotation(annotationsConfig, cc))
      : []
    : [];

  return dataflowDDBContentConstraints.length ? dataflowDDBContentConstraints[0] : null;

}